/* This function is used in components that fetch orders */
import type { IOrder } from '@rogue/universal'
import type { IRogue } from '@/js/services/RogueTypes'

// Default currencies for each store
const CURRENCY:{[key: string] : string} = {
  1  : 'USD',
  2  : 'CAD',
  4  : 'USD',
  5  : 'EUR',
  18 : 'AUD',
  34 : 'GBP',
}

export default function updateOrderInfo(order: IOrder & { [key: string]: any }, rogue: IRogue) {
  order.orderCreatedAt = (
    order.orderCreatedAt
    || order.meta?.createdAt
    || order.meta?.updatedAt
    || order.createdAt
  )
  order.trackRoute = {
    name  : 'rss',
    query : {
      token: encodeURIComponent(order.rssToken),
    },
  }

  if (!order.currency) {
    order.currency = CURRENCY[order.storeId] || rogue.site.currency
  }
}
